import 'css-chunksrc/client/pages/projectPortfoliosPage/projectPortfolios/projectPortfolio/loader/project/styles.scss';export default {
  "project": "_project_tiwz5_1"
};